import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const Moment = require('moment');

const AdminAnalyticsActions = require('../../actions/AdminAnalyticsActions');
const AdminAnalyticsStore = require('../../stores/AdminAnalyticsStore');
const ServerRequest = require('../../actions/request');

import DateRangePicker from '../common/DateRangePicker';
import TimeseriesChart from '../chart/TimeseriesChart';
import DefinitionListMapped from '../common/definition_list_mapped';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: "",
};

class AdminOverviewRange extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: Moment().subtract(1, 'M').toDate(),
            endDate: new Date(),
            getStatsActionId: null,
            getActInstTemplateActionId: null,
            getUserStatsActionId: null,
            analyticsStoreState: AdminAnalyticsStore.getState()
        };

        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onStatsUpdate = this.onStatsUpdate.bind(this);
        this._refreshStats = this._refreshStats.bind(this);
        this.unsubscribes = [AdminAnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this))];
        this.pollTaskManager = new ServerRequest.PollTaskManager();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => { u(); });
        this.pollTaskManager.abandonTasks();
    }

    onAnalyticsStoreChange(newState) {
        let additionalState = {};

        if (newState.action.id === this.state.getStatsActionId) {
            additionalState = { getStatsActionId: null };
        }

        if (newState.action.id === this.state.getActInstTemplateActionId) {
            additionalState = { getActInstTemplateActionId: null };
        }

        if (newState.action.id === this.state.getUserStatsActionId) {
            additionalState = { getUserStatsActionId: null };
        }

        this.setState({ analyticsStoreState: newState, ...additionalState });
    }

    onStartDateChange(newDate) {
        this.setState({ startDate: newDate });
    }

    onEndDateChange(newDate) {
        this.setState({ endDate: newDate });
    }

    onStatsUpdate(e) {
        if (!!this.state.getStatsActionId || !!this.getUserStatsActionId) {
            return;
        }

        this._refreshStats();
    }

    _refreshStats() {
        const getStatsActionId = uuid.v4();
        const getUserStatsActionId = uuid.v4();
        const getActInstTemplateActionId = uuid.v4();
        if (this.state.getActInstTemplateActionId) {
            this.pollTaskManager.cancelAction(this.state.getActInstTemplateActionId);
        }
        if (this.state.getUserStatsActionId) {
            this.pollTaskManager.cancelAction(this.state.getUserStatsActionId);
        }
        this.setState({
            getStatsActionId,
            getActInstTemplateActionId,
            getUserStatsActionId
        }, () => {
            const dateRange = {
                startDate: Moment(this.state.startDate),
                endDate: Moment(this.state.endDate)
            };
            AdminAnalyticsActions.getAdminOverviewStatsRange(getStatsActionId, dateRange);
            AdminAnalyticsActions.getAdminActInstTemplateRange(getActInstTemplateActionId, dateRange, this.pollTaskManager);
            AdminAnalyticsActions.getAdminOverviewUsersRange(getUserStatsActionId, dateRange, this.pollTaskManager);
        });
    }

    render() {
        const chartData = this.state.analyticsStoreState.adminOverviewRange;
        const actInstTemplateChartData = this.state.analyticsStoreState.adminOverviewActInstTemplateRange;
        const userChartData = this.state.analyticsStoreState.adminOverviewUsersRange;

        return (
            <div className={this.props.className}>
                <h2 className="view-title">Overview: Range</h2>
                <div className="flex-row-wrap margin-bottom-lg">
                    <DateRangePicker
                        className="flex-row-wrap"
                        minDate={Moment("2015-01-01").toDate()}
                        onStartDateChange={this.onStartDateChange}
                        onEndDateChange={this.onEndDateChange}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                    />
                    <button
                    className="btn btn-primary"
                    disabled={!!this.state.getStatsActionId}
                    onClick={this.onStatsUpdate}>
                        Update
                    </button>
                </div>
                { !!chartData &&
                    <div className="margin-bottom-lg">
                        <h3 className="md-heading">Data Objects</h3>
                        <TimeseriesChart
                        id="admin-overview-range-chart"
                        height={300}
                        labelShow={false}
                        legendShow={true}
                        yInt={true}
                        columns={chartData.graphData}
                        />
                        <DefinitionListMapped
                        className="inline-list-elems list-spaced"
                        definitions={chartData.totals}
                        />
                    </div>
                }
                { !!actInstTemplateChartData &&
                    <div className="margin-bottom-lg">
                        <h3 className="md-heading">Activity Instances Created by Template</h3>
                        <TimeseriesChart
                        id="admin-overview-ait-range-chart"
                        height={300}
                        labelShow={false}
                        legendShow={true}
                        yInt={true}
                        columns={actInstTemplateChartData.graphData}
                        />
                        <DefinitionListMapped
                        className="inline-list-elems list-spaced"
                        definitions={actInstTemplateChartData.totals}
                        />
                        <dl className="inline-list-elems list-spaced font-weight-bold">
                            <dt>Total</dt>
                            <dd>{actInstTemplateChartData.total}</dd>
                        </dl>
                    </div>
                }
                { !!userChartData &&
                    <div className="margin-bottom-lg">
                        <h3 className="md-heading">User Data</h3>
                        <TimeseriesChart
                        id="admin-overview-users-range-chart"
                        height={300}
                        labelShow={false}
                        legendShow={true}
                        yInt={true}
                        columns={userChartData.graphData}
                        />
                        <DefinitionListMapped
                        className="inline-list-elems list-spaced"
                        definitions={userChartData.totals}
                        />
                    </div>
                }
            </div>
        );
    }
}

AdminOverviewRange.propTypes = propTypes;
AdminOverviewRange.defaultProps = defaultProps;

export default AdminOverviewRange;